module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Honey_30_side.74069630.png";